import { type StoreApi, type UseBoundStore } from 'zustand'

import { useBulkImportStoreBase } from '@/components/BulkImportModal/store/bulk-import.store'
import { type AllowedCardTypesBulkImport } from '@/components/BulkImportModal/store/bulk-import.store.types'

type WithSelectors<S> = S extends { getState: () => infer T } ? S & { use: { [K in keyof T]: () => T[K] } } : never

const createSelectors = <S extends UseBoundStore<StoreApi<object>>>(_store: S) => {
  const store = _store as WithSelectors<typeof _store>

  store.use = {}
  for (const k of Object.keys(store.getState())) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    ;(store.use as any)[k] = () => store(s => s[k as keyof typeof s])
  }

  return store
}

export const useBulkImportStore = createSelectors(useBulkImportStoreBase)

export const useCardTypeBulkImportStore = () => {
  return useBulkImportStore.use.cardType() as AllowedCardTypesBulkImport
}
